"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var CfgCssClassEditor_1 = require("./component/CfgCssClassEditor");
var CfgCssClassList_1 = require("./component/CfgCssClassList");
var CfgCssClassListBase_1 = require("./lang/CfgCssClassListBase");
var PCfgCssClassList = /** @class */ (function (_super) {
    __extends(PCfgCssClassList, _super);
    function PCfgCssClassList(props) {
        return _super.call(this, props) || this;
    }
    PCfgCssClassList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_CT = this.props.cssTypesList.Subscribe("*", function (id, data) {
            _this.setState({
                avail_csstypes: data.data
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            lang: CfgCssClassListBase_1.CfgCssClassListLangFactory.getLangInstance(this.props.state.getLang()),
            page_num: 1,
            page_size: this.props.state.getTablePageSize()
        }, function () {
            _this.props.cssTypesList.LoadData();
        });
    };
    PCfgCssClassList.prototype.componentWillUnmount = function () {
        this.props.cssTypesList.UnSubscribe(this.SID_CT);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PCfgCssClassList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PCfgCssClassList.prototype.onEditClick = function (id) {
        this.setState({ edit_mode: "EDIT", record: id });
    };
    PCfgCssClassList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PCfgCssClassList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PCfgCssClassList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(CfgCssClassEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), availCssTypes: this.state.avail_csstypes, lang: this.state.lang }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(CfgCssClassEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this), availCssTypes: this.state.avail_csstypes, lang: this.state.lang }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(CfgCssClassList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, lang: this.state.lang }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PCfgCssClassList.prototype.render = function () {
        return this.getRenderObject();
    };
    PCfgCssClassList.getPageDescription = function (state) {
        var lang = CfgCssClassListBase_1.CfgCssClassListLangFactory.getLangInstance("RU"); //state.getLang()
        return {
            icon: "css3-alt",
            iconKind: "bold",
            itemId: "item-" + routes_1.routes.page_config_css_config + "-id",
            itemTitle: lang.document_title,
            route: routes_1.routes.page_config_css_config,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PCfgCssClassList;
}(React.Component));
exports.default = PCfgCssClassList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_css_class/ui/PCfgCssClassList.tsx
// module id = 2357
// module chunks = 0